// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609300458/js/" + chunkId + "." + {"44":"a105fc86","225":"acf387ff","481":"5e75f8f2","486":"16ec0ccc","770":"941b1e80"}[chunkId] + ".0.6746382939046528.chunk.js";
};